import PasswordValidator from 'password-validator';

// --- Empty String validation ---
const EmptyStringSchema = new PasswordValidator();
EmptyStringSchema
  .is().min(1);

export const validateForEmptyString = (validationTarget: string): boolean => EmptyStringSchema
  .validate(validationTarget, { list: false }) as boolean;
